import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-fanshenhe",
  "use": "icon-icon-fanshenhe-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-fanshenhe\"><path d=\"M576 384H461.44l72.96-73.6-45.44-45.44L338.56 416l151.04 150.4 45.44-45.44L461.44 448H576a96 96 0 0 1 0 192H320v64h256a160 160 0 0 0 0-320z\" fill=\"#333333\" p-id=\"759\" /><path d=\"M512 32A480 480 0 1 0 992 512 480.64 480.64 0 0 0 512 32z m0 896A416 416 0 1 1 928 512 416.64 416.64 0 0 1 512 928z\" fill=\"#333333\" p-id=\"760\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol